import React, { useEffect, useState } from 'react';
import {
  ProgressBarContainer,
  Segment,
  ProgressIndicator,
  ProgressPercentage,
  Ruler,
  Mark
} from './styled';
import { TbTriangleInvertedFilled } from 'react-icons/tb';

const SLAProgressbar = ({ total, remaining }) => {
  const adjustedRemaining = Math.max(remaining, 0);
  const finalPercentage = Math.min((adjustedRemaining / total) * 100, 100);
  const [animatedPercentage, setAnimatedPercentage] = useState(0);
  const indicatorPosition = `calc(${animatedPercentage}% - 10px)`;

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimatedPercentage((prevPercentage) => {
        if (prevPercentage < finalPercentage) {
          return prevPercentage + 0.25;
        } else {
          clearInterval(interval);
          return finalPercentage;
        }
      });
    }, 5);

    return () => clearInterval(interval);
  }, [finalPercentage]);

  return (
    <>
      <ProgressBarContainer>
        <Segment />
        <Segment />
        <Segment />
        <Segment />
        <ProgressIndicator
          style={{ '--indicator-final-position': indicatorPosition }}
        >
          <TbTriangleInvertedFilled />
        </ProgressIndicator>
        <ProgressPercentage
          style={{ '--indicator-final-position': indicatorPosition }}
        >
          {animatedPercentage.toFixed(2)}%
        </ProgressPercentage>
      </ProgressBarContainer>
      <Ruler>
        <Mark>0%</Mark>
        <Mark>25%</Mark>
        <Mark>50%</Mark>
        <Mark>75%</Mark>
        <Mark>100%</Mark>
      </Ruler>
    </>
  );
};

export default SLAProgressbar;
